<viz-footer contactLink={{mailToTag}}
            contactDisplay="Contact"
            termsLink=" "
            termsDisplay=" "
            appTitle="Enterprise Cross-Reference Consumption"
            copyright="Vizient Inc. All Rights Reserved">
</viz-footer>
